// AbMapSupplierTab — Lieferant-Stammdaten (ID/Name) + Erkennungs-Chips (detection.all_of).
// Bei unsupported-Regelsets nur zur Info (Bearbeitung im JSON-Tab, s. rulesetModel.js).

import React from 'react';
import { inputCls } from '../components/ui';

const AbMapSupplierTab = ({ isDarkMode, t, form, onChange, unsupported }) => {
  const textMuted = isDarkMode ? 'text-white/55' : 'text-slate-500';
  const labelCls = `text-[11px] uppercase tracking-wide font-semibold ${textMuted}`;

  const addDetection = (e) => {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    const v = e.target.value.trim();
    if (v) { onChange({ detection: [...form.detection, v] }); e.target.value = ''; }
  };
  const removeDetection = (idx) => onChange({ detection: form.detection.filter((_, i) => i !== idx) });

  return (
    <section className="space-y-4">
      <h3 className={`text-sm font-semibold ${isDarkMode ? 'text-white/80' : 'text-slate-700'}`}>{t('ab.map.tab.supplier')}</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div>
          <label className={labelCls}>{t('ab.map.supplierIdLabel')}</label>
          <input
            value={form.supplierId} disabled={unsupported} placeholder={t('ab.map.supplierIdPlaceholder')}
            onChange={(e) => onChange({ supplierId: e.target.value })}
            className={`${inputCls(isDarkMode)} w-full mt-1`}
          />
        </div>
        <div>
          <label className={labelCls}>{t('ab.map.supplierNameLabel')}</label>
          <input
            value={form.supplierName} disabled={unsupported} placeholder={t('ab.map.supplierNamePlaceholder')}
            onChange={(e) => onChange({ supplierName: e.target.value })}
            className={`${inputCls(isDarkMode)} w-full mt-1`}
          />
        </div>
      </div>

      <div>
        <label className={labelCls}>{t('ab.map.detectionLabel')}</label>
        <div className="flex flex-wrap gap-1.5 mt-1.5">
          {form.detection.map((d, i) => (
            <span key={`${d}-${i}`} className={`inline-flex items-center gap-1 text-xs font-medium px-2 py-1 rounded-md ${isDarkMode ? 'bg-white/10 text-white/75' : 'bg-slate-100 text-slate-700'}`}>
              {d}
              {!unsupported && (
                <button type="button" onClick={() => removeDetection(i)} className={isDarkMode ? 'text-white/40 hover:text-white' : 'text-slate-400 hover:text-slate-700'} aria-label={t('common.delete')}>×</button>
              )}
            </span>
          ))}
          {!unsupported && (
            <input
              placeholder={t('ab.map.detectionPlaceholder')} onKeyDown={addDetection}
              className={`${inputCls(isDarkMode)} text-xs px-2 py-1 min-w-[160px]`}
            />
          )}
        </div>
        <p className={`text-xs mt-2 ${textMuted}`}>{unsupported ? t('ab.map.unsupportedIdentityHint') : t('ab.map.detectionHint')}</p>
      </div>
    </section>
  );
};

export default AbMapSupplierTab;
